// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__GI2OI","header":"ReportDetails_header__3UXbh","title":"ReportDetails_title__2ECqV","left":"ReportDetails_left__2oZwL"};